import { createAction } from "redux-actions";

export const setAuthPolicy = createAction("SET_AUTH_POLICE");

export const setSidParams = createAction("SET_SID_PARAMS");

export const mergeAppState = createAction("MERGE_APP_STATE");

export const logOut = createAction("LOGOUT");

export const storeShortUrl = createAction(`STORE_SHORT_URL`);
export const mergeShortUrl = createAction(`MERGE_SHORT_URL`);

export const getShortUrl = createAction(`GET_SHORT_URL`);
export const getShortUrlSuccess = createAction(`GET_SHORT_URL/SUCCESS`);
export const getShortUrlError = createAction(`GET_SHORT_URL/ERROR`);